import styled from 'styled-components';
import { remCalc, colors, layout } from '@prisjakt/ui-base';

const PAGE_MARGIN_TOP = 10;
const PAGE_MARGIN_BOTTOM = 30;
export const PrivacyLink = styled.div`
  margin-bottom: ${remCalc(30)};
  a {
    text-decoration: underline;
  }
`;

export const Section = styled.section`
  margin-top: ${remCalc(PAGE_MARGIN_TOP)};
  margin-bottom: ${remCalc(PAGE_MARGIN_BOTTOM)};
  padding: 0 ${layout.pageContent.gutter.rem};
  article {
    max-width: 700px;
    h1 {
      font-size: ${remCalc(30)};
    }
    a {
      color: ${colors.lightBlue3};
      text-decoration: underline;
    }
    a:hover {
      color: ${colors.green1};
    }
    ul,
    ol {
      list-style-position: inside;
    }
  }
`;
